import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./listings.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { calculateGridItemSize, calculateMaxRecords } from '~/modules/helpers/gridItemHelper';
import { navigateEvent } from '~/modules/helpers/navigationHelper';
import { contentStore } from '~/modules/stores/contentStore';
import { WireI18n } from '~/modules/stores/i18nStore';
import { userStore } from '~/modules/stores/userStore';
import { getCookie } from '~/modules/utilities/cookies';
class Listing extends LightningElement {
  constructor(...args) {
    super(...args);
    // @ts-expect-error * Automated Type Error Fix
    this.i18n = void 0;
    this.store = {
      isLoading: true,
      isError: false,
      isEmpty: true,
      records: []
    };
    // @ts-expect-error * Automated Type Error Fix
    this.gridItemSize = void 0;
    this.maxRecords = 9;
    this._props = {};
  }
  setCurrentUser(userState) {
    const currentSid = this.sid;
    if (userState.isGuestUser) {
      this.sid = null;
    } else {
      this.sid = getCookie('sid');
    }
    const sidHasChanged = currentSid !== this.sid;
    if (sidHasChanged) {
      this.calculateSizes(userState.isGuestUser);
    }
  }
  connectedCallback() {
    this.fetchRecords();
  }
  calculateSizes(isGuestUser) {
    this.gridItemSize = calculateGridItemSize(isGuestUser, this._props);
    // if dims is empty 9 is max number of records
    this.maxRecords = calculateMaxRecords(isGuestUser, this._props, 9);
  }
  set props(value) {
    this._props = value;
    this.calculateSizes(userStore.getState().isGuestUser);
  }
  get props() {
    return {
      format: 'listing',
      showMore: this._props._showMore,
      ...this._props
    };
  }
  get storeName() {
    return this.props.type;
  }
  fetchRecords() {
    if (this.props.url) {
      contentStore.fetchFeeds(this.props.url, this.storeName);
    }
  }
  get records() {
    return this.store.records.slice(0, this.maxRecords);
  }
  //
  // eslint-disable-next-line dot-notation
  //, selector: (state) => state['$name']
  // @ts-expect-error * Automated Type Error Fix
  // @ts-expect-error * Automated Type Error Fix
  setRecords(data, error) {
    if (data && data[this.storeName]) {
      this.store = data[this.storeName];
    } else if (error) {
      this.store.isError = true; // in this case is not connected to store
    }
  }
  handleNavigate(event) {
    if (event.detail?.listing?.listingUrl) {
      const url = event.detail.listing.listingUrl;
      navigateEvent(url, event.detail.event);
    }
  }
  handleRetry() {
    this.fetchRecords();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Listing, {
  publicProps: {
    props: {
      config: 3
    }
  },
  track: {
    store: 1,
    gridItemSize: 1,
    maxRecords: 1
  },
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    },
    setCurrentUser: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: userStore
        };
      }
    },
    setRecords: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: contentStore,
          selector: state => state.feeds
        };
      }
    }
  },
  fields: ["_props"]
});
const __lwc_component_class_internal = _registerComponent(Listing, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;